import { render, staticRenderFns } from "./NavigationMainAudio.vue?vue&type=template&id=450e6c54&scoped=true&"
import script from "./NavigationMainAudio.vue?vue&type=script&lang=js&"
export * from "./NavigationMainAudio.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMainAudio.vue?vue&type=style&index=0&id=450e6c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e6c54",
  null
  
)

export default component.exports